import { useState } from 'react';
import { isArray } from 'lodash';
import { getWindow } from '../../../../utils/getWindow';

const SELECTED_POSTS_KEY = 'create-collection-selected-posts';
const QUERY_STRING_KEY = 'create-collection-query-string';

export const useCreateCollectionSessionStorage = () => {
    const [selectedPosts, setSelectedPostsValue] = useState<string[]>(() => {
        try {
            const item = getWindow()?.sessionStorage.getItem(SELECTED_POSTS_KEY);

            const value = item && JSON.parse(item);

            return isArray(value) ? value : [];
        } catch (error) {
            return [];
        }
    });

    const setSelectedPosts = (value: string[] | Function) => {
        const valueToStore = value instanceof Function ? value(selectedPosts) : value;
        setSelectedPostsValue(valueToStore);
        getWindow()?.sessionStorage.setItem(SELECTED_POSTS_KEY, JSON.stringify(valueToStore));
    };

    const queryStringDefault = getWindow()?.sessionStorage.getItem(QUERY_STRING_KEY);
    const [queryString, setQueryStringValue] = useState<string>(queryStringDefault ?? '');

    const setQueryString = (value: string | Function) => {
        const valueToStore = value instanceof Function ? value(selectedPosts) : value;
        setQueryStringValue(valueToStore);
        getWindow()?.sessionStorage.setItem(QUERY_STRING_KEY, valueToStore);
    };

    const clearValue = () => {
        setSelectedPostsValue([]);
        setQueryStringValue('');
        getWindow()?.sessionStorage.removeItem(SELECTED_POSTS_KEY);
        getWindow()?.sessionStorage.removeItem(QUERY_STRING_KEY);
    };

    return { selectedPosts, setSelectedPosts, clearValue, queryString, setQueryString };
};
